var map = {
	"./gallery-wip-ammo-port-enclosure-body_00.jpg": 2937,
	"./gallery-wip-ammo-port-enclosure-body_01.jpg": 2938,
	"./gallery_00.jpg": 2939,
	"./gallery_01.jpg": 2940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2936;